"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoPlayerRequestStatus = exports.getFetchFilesRequestStatus = exports.getFilesTotal = exports.getFiles = void 0;

var getFiles = function getFiles(state) {
  return state.files.get('objects');
};

exports.getFiles = getFiles;

var getFilesTotal = function getFilesTotal(state) {
  return state.files.get('total');
};

exports.getFilesTotal = getFilesTotal;

var getFetchFilesRequestStatus = function getFetchFilesRequestStatus(state) {
  return state.files.get('status');
};

exports.getFetchFilesRequestStatus = getFetchFilesRequestStatus;

var getVideoPlayerRequestStatus = function getVideoPlayerRequestStatus(state) {
  return state.files.get('videoPlayerRequestStatus');
};

exports.getVideoPlayerRequestStatus = getVideoPlayerRequestStatus;